import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';
import { SessionCallProntuarioAudioVisualizer } from './SessionCallProntuarioAudioVisualizer';
import { SessionCallProntuarioHintBalloon } from './SessionCallProntuarioHintBalloon';

type SessionCallProntuarioBadgeHint = 'hidden' | 'initial';

type SessionCallProntuarioRecordingBadgeProps = {
	onOpen: () => void;
	hint?: SessionCallProntuarioBadgeHint;
	hintMessage?: string;
	transcriptionActive?: boolean;
	onDismissHint?: () => void;
	className?: string;
};

const SessionCallProntuarioRecordingBadge = ({
	onOpen,
	hint = 'hidden',
	hintMessage = 'Esta sessão está sendo registrada e transcrita. Clique aqui para abrir o prontuário.',
	transcriptionActive = true,
	onDismissHint,
	className,
}: SessionCallProntuarioRecordingBadgeProps) => {
	const showHint = hint !== 'hidden';

	return (
		<div className={cn('relative', className)}>
			{showHint ? (
				<SessionCallProntuarioHintBalloon
					id="prontuario-badge-hint"
					message={hintMessage}
					onDismiss={() => onDismissHint?.()}
					placement="above"
					align="end"
				/>
			) : null}

			<button
				type="button"
				onClick={onOpen}
				data-tutorial-demo="prontuario-open-badge"
				aria-label="Abrir prontuário"
				aria-describedby={
					showHint ? 'prontuario-badge-hint' : undefined
				}
				className={cn(
					'group flex items-center overflow-hidden',
					'rounded-l-xl border-y border-l border-white/[0.08]',
					'bg-[#121A24]/95 backdrop-blur-sm',
					'shadow-[-4px_4px_20px_rgba(0,0,0,0.35)]',
					'py-1.5 pl-1.5 pr-2.5',
					'transition-[padding,box-shadow,background-color] duration-300 ease-out',
					'hover:bg-[#1a2430]/95 hover:pl-2 hover:shadow-[0_6px_24px_rgba(0,0,0,0.45)]',
					showHint && 'ring-2 ring-[#8ab4f8]/35',
				)}
			>
				<span
					className={cn(
						'flex w-0 shrink-0 items-center justify-center overflow-hidden text-[#8ab4f8] opacity-0',
						'transition-[width,opacity,margin] duration-300 ease-out',
						'group-hover:mr-1.5 group-hover:w-4 group-hover:opacity-100',
					)}
					aria-hidden
				>
					<ChevronLeft className="size-4" strokeWidth={2.5} />
				</span>

				<SessionCallProntuarioAudioVisualizer
					decorative
					animated={transcriptionActive}
					className="h-[26px] min-w-[48px] rounded-md bg-[#2d2f32] px-2.5"
				/>
				{/* <span className="whitespace-nowrap pl-2 text-[12px] font-medium tracking-wide text-slate-200">
          Prontuário
        </span> */}
			</button>
		</div>
	);
};

export {
	SessionCallProntuarioRecordingBadge,
	type SessionCallProntuarioBadgeHint,
};
